import moment from "moment";
import { getUpdatedBrandGroupListWithBrandList } from "../../constants";

let initialState = {
  templateData: null,
  templateDetails: null,
  createSection: null,
  deleteSection: null,
  sectionData: null,
  account_list: null,
  brands: null,
  brandlogicalgroup: null,
  templateResponseId: null,
  addWidgetResponse: null,
  deleteWidgetResponse: null,
  widgetLoader: false,
  updateSectionFilters: null,
  updateWidgetFilters: null,
  templateListType: "dashboard",
  templateListLoader: false,
  loaderForBrandGroupPopover: false,
  userBrandLoader: false,
  templateSectionFetchLoader: false,
  globalLoader: false,
  sectionLoader: false,
  shareableLink: null,
  shareBrands: null,
  allow_multiple_brand: false,
  shareTemplateData: null,
  shareCategory: null,
  downloadId: null,
  unMaskedInfo: { tagids: [] },
  unMaskedInfoId: [],
  shareLoaders: {
    brandsFetchLoader: false,
    templateFetchLoader: false,
    graphFetchLoader: false,
  },
  shareableUserData: null,
  defaultShareableUserData: null,
  pinDashboard: null,
  unPinDashboard: null,
  pin: false,
  shareableLinkStatus: null,
  passwordStatus: null,
  passwordLoader: null,
  sharedWithTeam: null,
  is_edited: false,
  ticketOverviewInterval: 720,
  ticketOverviewRoleType: -1,
  ticketOverviewWidget1: 720,
  ticketOverviewWidget2: 720,
  selectedTatWidgetMonth: 1,
  socialMediaProfileList: null,
  socialMediaProfileData: {
    profileImg: null,
    coverImg: null,
    screenName: null,
    author_id: null,
    bta_id: null,
  },
  socialMediaDropdownOptions: {
    widget3: 60,
    widget5: 60,
    widget7: 60,
    widget11: 60,
    widget13: 60,
  },
  isPdfModalOpen: false,
  dashboardPdfLoader: false,
  pdfGenerateStatus: false,
  dashboardPdfdata: null,
  dashboardPills: null,
  dashboardQuickFilter: null,
  PPTdashboardData: false,
  shareableLinkDeepDiveStatus: false,
  workspace_privileges: null,
  share_workspace_privileges: null,
  login_account_type: null,
  shareableUserDataLoader: false,
  dashboard_total_page_no: null,
  dashboardPaginationFilters: {
    search_text: "",
    pill: "All Dashboards",
    offset: 0,
    no_of_rows: 12,
    sort_expression: null,
    sort_order: null,
    type: "dashboard",
  },
  is_dashboard_created: false,
  is_schedule_report_open: false,
  is_dashboard_schedule_modal: false,
  is_dashboard_schedule_template: null,
  schedule_current_step: 0,
  reach_current_time: moment(new Date(new Date().getTime())).format("HH:mm"),
  widget_update_filter_loader: false,
  pinnedTemplateListData: null,
  pinnedTemplateListLoader: false,
  mentionTrendsData: null,
  mentionTrendsLoader: false,
  duplicateDashboardLoader: false,
  duplicateDashboardFlag: false,
  saveDashboardModalFlag: false,
  saveEditedDashboardModalFlag: false,
  closeDashboardFlag: false,
  openNewDashboardFlag: false,
  relatedDashboardFlag: false,
  brandHiddenWords: null,
  multileProfileSelection: {
    searchQuickFilterLoader: false,
    allow_multiple_selection: false,
    profile_list: [],
    profileInfo: null,
    quick_filter_value: null,
    adsset_list: [],
    adsset_value: null,
    ads_list: [],
    ads_value: null,
    selected_profile: null,
  },
  widget_maker_chart_type_list: [],
};

const ApiCall = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TEMPLATE_LIST_TYPE":
      return {
        ...state,
        templateListType: action.payload,
      };
    case "SET_PPT_DASHBOARD_DATA":
      return {
        ...state,
        PPTdashboardData: action.payload,
      };
    case "SET_TEMPLATE_DATA":
      return {
        ...state,
        templateData: action.payload,
      };
    case "SET_FETCH_TEMPLATE_DATA":
      return {
        ...state,
        templateDetails: action.payload,
      };
    case "SET_CREATE_SECTION":
      return {
        ...state,
        createSection: action.payload,
      };
    case "SET_DELETE_SECTION":
      return {
        ...state,
        deleteSection: action.payload,
      };
    case "SET_FETCH_SECTION_DATA":
      return {
        ...state,
        sectionData: action.payload,
      };
    case "SET_WORKSPACE_ACCOUNT_VALUE":
      return {
        ...state,
        account_list: action.payload,
      };
    case "SET_UNMASKED_INFO":
      return {
        ...state,
        unMaskedInfo: action.payload,
      };
    case "SET_UNMASKED_INFO_ID":
      return {
        ...state,
        unMaskedInfoId: action.payload,
      };
    case "SET_WORKSPACE_BRAND_VALUE":
      return {
        ...state,
        brands: action.payload,
      };
    case "SET_ROI_DETAILS_IN_BRAND_VALUE":
      let roiDetailsValue = {
        roi_details: action.roiDetails,
      };
      return {
        ...state,
        brands: {
          ...state?.brands,
          data: {
            ...state?.brands?.data,
            result: {
              ...state?.brands?.data?.result,
              ...roiDetailsValue,
            },
          },
        },
      };
    case "SET_WORKSPACE_PRIVILEGES":
      return {
        ...state,
        workspace_privileges: action.payload,
      };
    case "SET_SHARE_WORKSPACE_PRIVILEGES":
      return {
        ...state,
        share_workspace_privileges: action.payload,
      };
    case "SET_LOGIN_ACCOUNT_TYPE":
      return {
        ...state,
        login_account_type: action.payload,
      };
    case "SET_SAVE_TEMPLATE_RESPONSE":
      return {
        ...state,
        templateResponseId: action.payload,
      };
    case "SET_ADD_WIDGET_IN_SECTION":
      return {
        ...state,
        addWidgetResponse: action.payload,
      };
    case "SET_DELETE_WIDGET_FROM_SECTION":
      return {
        ...state,
        deleteWidgetResponse: action.payload,
      };
    case "SET_WIDGET_LOADER":
      return {
        ...state,
        widgetLoader: action.payload,
      };
    case "SET_UPDATE_FILTERS_IN_SECTION":
      return {
        ...state,
        updateSectionFilters: action.payload,
      };
    case "SET_UPDATE_FILTERS_IN_WIDGET":
      return {
        ...state,
        updateWidgetFilters: action.payload,
      };
    case "SET_TEMPLATE_LIST_LOADER":
      return {
        ...state,
        templateListLoader: action.payload,
      };
    case "SET_TEMPLATE_SECTION_FETCH_LOADER":
      return {
        ...state,
        templateSectionFetchLoader: action.payload,
      };
    case "SET_GLOBAL_LOADER":
      return {
        ...state,
        globalLoader: action.payload,
      };
    case "SET_USER_BRAND_LOADER":
      return {
        ...state,
        userBrandLoader: action.payload,
      };
    case "SET_LOADER_FOR_BRAND_GROUP_POPOVER":
      return {
        ...state,
        loaderForBrandGroupPopover: action?.value,
      };

    case "SET_SECTION_LOADER":
      return {
        ...state,
        sectionLoader: action.payload,
      };
    case "SET_PDF_MODAL_OPEN":
      return {
        ...state,
        isPdfModalOpen: action.payload,
      };
    case "SET_PDF_LOADER":
      return {
        ...state,
        dashboardPdfLoader: action.payload,
      };
    case "SET_PDF_GENERATE_STATUS":
      return {
        ...state,
        pdfGenerateStatus: action.payload,
      };
    case "SET_PDF_DATA":
      return {
        ...state,
        dashboardPdfdata: action.payload,
      };
    case "SET_SHARE_ID_RESPONSE":
      return {
        ...state,
        shareableLink: action.payload,
      };

    case "SET_SHARE_BRANDS":
      return {
        ...state,
        shareBrands: action.payload,
      };
    case "SET_BRANDS_IN_SHARE_BRAND_VALUE":
      return {
        ...state,
        shareBrands: {
          ...state.shareBrands,
          brands: action.brands,
        },
      };
    case "SET_ROI_DETAILS_IN_SHARE_BRAND_VALUE":
      return {
        ...state,
        shareBrands: {
          ...state.shareBrands,
          roi_details: action.roiDetails,
        },
      };
    case "SET_SHARE_TEMPLATE_DATA":
      // to maintain quick filter value in share case
      let updatedShareTemplateData = { ...state.shareTemplateData };
      let recievedQuickFilters = action.payload;
      if (
        updatedShareTemplateData?.filter_templates ||
        updatedShareTemplateData?.pinned_filter_templates
      ) {
        recievedQuickFilters = {
          ...recievedQuickFilters,
          filter_templates: updatedShareTemplateData?.filter_templates
            ? [...updatedShareTemplateData?.filter_templates]
            : updatedShareTemplateData?.filter_templates || [],
          pinned_filter_templates:
            updatedShareTemplateData?.pinned_filter_templates
              ? [...updatedShareTemplateData?.pinned_filter_templates]
              : updatedShareTemplateData?.pinned_filter_templates || [],
        };
      }
      if (updatedShareTemplateData?.profile_list?.length > 0) {
        recievedQuickFilters = {
          ...recievedQuickFilters,
          profile_list: updatedShareTemplateData?.profile_list
            ? [...updatedShareTemplateData?.profile_list]
            : updatedShareTemplateData?.profile_list || [],
        };
      }
      if (updatedShareTemplateData?.quick_filter_value) {
        recievedQuickFilters = {
          ...recievedQuickFilters,
          quick_filter_value: updatedShareTemplateData?.quick_filter_value
            ? { ...updatedShareTemplateData?.quick_filter_value }
            : null,
        };
      }
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          ...recievedQuickFilters,
        },
      };
    case "SET_QUICK_FILTERS_IN_SHARE_TEMPLATE_DATA":
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          filter_templates: action?.filter_templates
            ? [...action?.filter_templates]
            : state?.shareTemplateData?.filter_templates || [],
          pinned_filter_templates: action?.pinned_filter_templates
            ? [...action?.pinned_filter_templates]
            : state?.shareTemplateData?.pinned_filter_templates || [],
        },
      };
    case "SET_SHARE_CATEGORY":
      return {
        ...state,
        shareCategory: action.payload,
      };
    case "SET_DOWNLOAD_ID":
      return {
        ...state,
        downloadId: action.payload,
      };
    case "SET_SHARE_LOADERS":
      return {
        ...state,
        shareLoaders: action.payload,
      };
    case "SET_SHAREABLE_USER_DATA":
      return {
        ...state,
        shareableUserData: action.payload,
      };
    case "SET_DEFAULT_SHAREABLE_USER_DATA":
      return {
        ...state,
        defaultShareableUserData: action.payload,
      };
    case "SET_PINNED_DASHBOARD":
      return {
        ...state,
        pinDashboard: action.payload,
      };
    case "SET_UNPIN_DASHBOARD":
      return {
        ...state,
        unPinDashboard: action.payload,
      };
    case "SET_PIN":
      return {
        ...state,
        pin: action.payload,
      };
    case "SET_SHAREABLE_LINK_STATUS":
      return {
        ...state,
        shareableLinkStatus: action.payload,
      };
    case "SET_SHAREABLE_LINK_DEEP_DIVE_STATUS":
      return {
        ...state,
        shareableLinkDeepDiveStatus: action.payload,
      };
    case "SET_PASSWORD_STATUS":
      return {
        ...state,
        passwordStatus: action.payload,
      };
    case "SET_PASSWORD_LOADER":
      return {
        ...state,
        passwordLoader: action.payload,
      };
    case "SET_SHARED_WITH_TEAM_DATA":
      return {
        ...state,
        sharedWithTeam: action.payload,
      };
    case "SET_BRAND_LOGICAL_GROUP_VALUE":
      return {
        ...state,
        brandlogicalgroup: action.payload,
      };
    case "SET_BRAND_LIST_IN_LOGICAL_GROUP_VALUE":
      let brandGroupList = state?.brandlogicalgroup?.data?.result;
      let stateValue = {
        updateForTheseBrandGroups: action?.updateForTheseBrandGroups,
        groupWithBrandList: action?.groupWithBrandList,
      };
      let updatedBrandGroupList = getUpdatedBrandGroupListWithBrandList(
        brandGroupList,
        stateValue
      );
      return {
        ...state,
        brandlogicalgroup: {
          ...state?.brandlogicalgroup,
          data: {
            ...state?.brandlogicalgroup?.data,
            result: updatedBrandGroupList?.length
              ? updatedBrandGroupList
              : state?.brandlogicalgroup?.result,
          },
        },
      };
    case "SET_CHECK_EDITED":
      return {
        ...state,
        is_edited: action.payload,
      };
    case "SET_TICKET_OVERVIEW_INTERVAL":
      return {
        ...state,
        ticketOverviewInterval: action.payload,
      };
    case "SET_TICKET_OVERVIEW_ROLETYPE":
      return {
        ...state,
        ticketOverviewRoleType: action.payload,
      };
    case "SET_TICKET_OVERVIEW_WIDGET_1":
      return {
        ...state,
        ticketOverviewWidget1: action.payload,
      };
    case "SET_TICKET_OVERVIEW_WIDGET_2":
      return {
        ...state,
        ticketOverviewWidget2: action.payload,
      };
    case "SET_SELECTED_TAT_WIDGET_MONTH":
      return {
        ...state,
        selectedTatWidgetMonth: action.payload,
      };
    case "SET_SELECTED_TAT_TITLE_MONTH":
      return {
        ...state,
        selectedTatTitleMonth: action.payload,
      };
    case "SET_SOCIAL_MEDIA_PROFILE_DATA":
      return {
        ...state,
        socialMediaProfileData: action.payload,
      };
    case "SET_SOCIAL_MEDIA_DROPDOWN_OPTIONS":
      return {
        ...state,
        socialMediaDropdownOptions: action.payload,
      };
    case "SET_DASHBOARD_PILLS":
      return {
        ...state,
        dashboardPills: action.payload,
      };
    case "SET_DASHBOARD_QUICK_FILTER":
      return {
        ...state,
        dashboardQuickFilter: action.payload,
      };
    case "SET_WORDCLOUD_MODIFY_WORDS":
      return {
        ...state,
        wordcloud_modify_words: action.payload,
      };
    case "SET_SHAREABLE_USER_DATA_LOADER":
      return {
        ...state,
        shareableUserDataLoader: action.payload,
      };
    case "SET_DASHBOARD_TOTAL_PAGE_NO":
      return {
        ...state,
        dashboard_total_page_no: action.payload,
      };

    case "SET_DASHBOARD_PAGINATION_FILTERS":
      return {
        ...state,
        dashboardPaginationFilters: action.payload,
      };
    case "SET_IS_DASHBOARD_CREATED":
      return {
        ...state,
        is_dashboard_created: action.payload,
      };
    case "SET_IS_SCHEDULE_REPORT_OPEN":
      return {
        ...state,
        is_schedule_report_open: action.payload,
      };
    case "SET_IS_DASHBOARD_SCHEDULE_MODAL":
      return {
        ...state,
        is_dashboard_schedule_modal: action.payload,
      };
    case "SET_IS_DASHBOARD_SCHEDULE_TEMPLATE":
      return {
        ...state,
        is_dashboard_schedule_template: action.payload,
      };
    case "SET_SCHEDULE_CURRENT_STEP":
      return {
        ...state,
        schedule_current_step: action.payload,
      };
    case "SET_REACH_CURRENT_TIME":
      return {
        ...state,
        reach_current_time: action.payload,
      };
    case "SET_WIDGET_UPDATE_FILTER_LOADER":
      return {
        ...state,
        widget_update_filter_loader: action.payload,
      };
    case "SET_PINNED_TEMPLATE_LIST_DATA":
      return {
        ...state,
        pinnedTemplateListData: action.payload,
      };
    case "SET_PINNED_TEMPLATE_LIST_LOADER":
      return {
        ...state,
        pinnedTemplateListLoader: action.payload,
      };
    case "SET_MENTION_TRENDS_WIDGET_DATA":
      return {
        ...state,
        mentionTrendsData: action.payload,
      };
    case "SET_MENTION_TRENDS_LOADER":
      return {
        ...state,
        mentionTrendsLoader: action.payload,
      };
    case "SET_DUPLICATE_DASHBOARD_LOADER":
      return {
        ...state,
        duplicateDashboardLoader: action.payload,
      };
    case "SET_DUPLICATE_DASHBOARD_FLAG":
      return {
        ...state,
        duplicateDashboardFlag: action.payload,
      };
    case "SET_SAVE_DASHBOARD_MODAL_FLAG":
      return {
        ...state,
        saveDashboardModalFlag: action.payload,
      };
    case "SET_SAVE_EDITED_DASHBOARD_MODAL_FLAG":
      return {
        ...state,
        saveEditedDashboardModalFlag: action.payload,
      };
    case "SET_CLOSE_DASHBOARD_FLAG":
      return {
        ...state,
        closeDashboardFlag: action.payload,
      };
    case "SET_RELATED_NEW_DASHBOARD_FLAG":
      return {
        ...state,
        relatedDashboardFlag: action.value,
      };
    case "SET_OPEN_NEW_DASHBOARD_FLAG":
      return {
        ...state,
        openNewDashboardFlag: action.payload,
      };
    case "SET_BRAND_HIDDEN_WORDS":
      return {
        ...state,
        brandHiddenWords: action.payload,
      };
    case "RESET_SHARE_DASHBOARD_SELECTED_PROFILE_SELECTION_INFO":
      return {
        ...state,
        multileProfileSelection: {
          ...initialState.multileProfileSelection,
        },
      };
    case "SET_SEARCH_QUICK_FILTER_LOADER":
      return {
        ...state,
        multileProfileSelection: {
          ...state.multileProfileSelection,
          searchQuickFilterLoader: action.value,
        },
      };
    case "SET_ALLOW_MULTIPLE_PROFILE_SELECTION":
      return {
        ...state,
        multileProfileSelection: {
          ...state.multileProfileSelection,
          allow_multiple_selection: action.allow_multiple_selection,
        },
      };
    case "SET_ALLOW_MULTIPLE_BRAND_SELECTION":
      return {
        ...state,
        allow_multiple_brand: action.allow_multiple_brand,
      };
    case "SET_PROFILE_LIST_IN_SHARE_DASHBOARD":
      return {
        ...state,
        shareTemplateData: {
          ...state.shareTemplateData,
          profile_list:
            Array.isArray(action?.profile_list) &&
            action?.profile_list?.length > 0
              ? action?.profile_list
              : [],
        },
      };

    case "SET_INITIAL_SHARE_DASHBOARD_SELECTED_QUICK_FILTER_VALUES":
      return {
        ...state,
        multileProfileSelection: {
          ...state.multileProfileSelection,
          profileInfo:
            action?.profileInfo ?? state?.multileProfileSelection?.profileInfo,
          quick_filter_value:
            action?.qucikFilterValue ??
            state?.multileProfileSelection?.quick_filter_value,
          adsset_list: action?.adssetList?.length > 0 ? action?.adssetList : [],
          adsset_value: action?.adssetValue ? action?.adssetValue : null,
          ads_list: action?.adsList?.length > 0 ? action?.adsList : [],
          ads_value: action?.adsValue ? action?.adsValue : null,
        },
      };
    case "SET_SHARE_DASHBOARD_SELECTED_QUICK_FILTER_VALUE":
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          profileInfo:
            action?.profileInfo ?? state?.shareTemplateData?.profileInfo,
          quick_filter_value:
            action?.qucikFilterValue ??
            state?.shareTemplateData?.quick_filter_value,
        },
      };
    case "SET_ADSSET_LIST_IN_SHARE_DASHBOARD":
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          adsset_list: action?.adssetList?.length > 0 ? action?.adssetList : [],
        },
      };
    case "SET_ADSSET_VALUE_IN_SHARE_DASHBOARD":
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          adsset_value: action?.adssetValue ? action?.adssetValue : null,
        },
      };
    case "SET_ADS_LIST_IN_SHARE_DASHBOARD":
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          ads_list: action?.adsList?.length > 0 ? action?.adsList : [],
        },
      };
    case "SET_ADS_VALUE_IN_SHARE_DASHBOARD":
      return {
        ...state,
        shareTemplateData: {
          ...state?.shareTemplateData,
          ads_value: action?.adsValue ? action?.adsValue : null,
        },
      };
    case "SET_CLEAR_GRAPH_DATA_IN_SHARE_TEMPLATE_DATA":
      let updatedShareTemplateDataWithClearGraphData = {
        ...state?.shareTemplateData,
      };
      if (action?.isOnlyWidgets) {
        updatedShareTemplateDataWithClearGraphData = {
          ...updatedShareTemplateDataWithClearGraphData,
          section: action?.sectionData,
        };
      } else {
        updatedShareTemplateDataWithClearGraphData = {
          ...updatedShareTemplateDataWithClearGraphData,
          sections: action?.sectionData,
        };
      }
      return {
        ...state,
        shareTemplateData: {
          ...updatedShareTemplateDataWithClearGraphData,
        },
      };
    case "SET_WIDGET_MAKER_CHART_TYPE_LIST":
      return {
        ...state,
        widget_maker_chart_type_list: action.payload,
      };
    default:
      return state;
  }
};

export default ApiCall;
